import { TimeSpan } from "@sparkware/app-utils";
import { observer } from "mobx-react";
import React, { useState, useEffect } from 'react';
import { namedSetTimeout } from "../../../../common/utils/time-functions";
import { DEFAULT_SWITCH_TO_SESSION_TIMER_WAIT_INTERVAL } from "../../../services/regulation/regulation-const";
import { LastLoginComponent } from "../last-login/last-login.component";
import { InLobbySessionTimerComponent } from "../session-timer/in-lobby/in-lobby-session-timer.component";
import {  LastLoginAndSessionTimerComponent } from "../last-login-and-session-timer/last-login-and-session-timer.component";

interface LastLoginSessionTimerSwitcherComponentProps {
    switchToSessionTimerInterval?: TimeSpan;
    showLastLoginForever?: boolean
}
export const LastLoginSessionTimerSwitcherComponent: React.FC<LastLoginSessionTimerSwitcherComponentProps> = observer((props) => {
    const [renderSessionTimer, setRenderSessionTimer] = useState(false);

    useEffect(() => {
        const timerId = namedSetTimeout('SWITCH_TO_SESSION_TIMER_WAIT_INTERVAL', () => {
            setRenderSessionTimer(true);
        }, props.switchToSessionTimerInterval || TimeSpan.fromMinutes(DEFAULT_SWITCH_TO_SESSION_TIMER_WAIT_INTERVAL));

        return () => {
            clearTimeout(timerId);
        };
    }, [props.switchToSessionTimerInterval]);

    if (props.showLastLoginForever && renderSessionTimer) {
        return (<LastLoginAndSessionTimerComponent />)
    } else if (renderSessionTimer) {
        return <InLobbySessionTimerComponent />
    } else {
        return <LastLoginComponent />
    }
})